export default __webpack_public_path__ + "static/media/bg-sidebar.544fc29e.jpg";